import { BaseFiltroPagDTO, IdNomeDTO } from './base-dto';
import { IUnitClient } from './client';
import IPrescription from './prescription';

interface ITranscription {
  id?: string;
  prescricoes: IPrescription[];
  prescricaoAprovada?: IPrescription;
  prescricaoAguardandoAprovacao?: IPrescription;
  prescricaoReferencia?: IPrescription;
  status: string;
  iniciadoPor: any;
  transcritorAtual: any;
  emProgresso: boolean;
  matches: string;
  minMatches: string;
  podeTranscrever: boolean;
  unidade?: IdNomeDTO;
  paciente?: IdNomeDTO;
  dataInclusao: string;
}

interface ITranscriptionFilter {
  patientId?: number;
  doctorId?: number;
  clientId?: number;
  prescriptionDate?: any;
  hospitalUnitId?: number;
  transcriptionStatus?: string | string[];
  startDate?: string;
  endDate?: string;
  prescriptionCreatedDate?: string;
  typeTranscription?: string;
  id?: number;
  hasPagination?: boolean;
  sortBy?: string;
  descending?: boolean;
  page?: number;
  rowsPerPage?: number;
  clientSelected: boolean;
  companySelected: boolean;
}

export class TranscricaoFiltroParmDTO extends BaseFiltroPagDTO {
  idUnidade: number;
  idMedico: number;
  idPaciente: number;
  id: string;
  dataProducaoInicio: string;
  dataProducaoFim: string;
  dataEntregaInicio: string;
  dataEntregaFim: string;
  dataCriacaoInicio: string;
  dataCriacaoFim: string;
  minhasTranscricoes: boolean;
  statusTranscricao: string[];
  bolsaMulti: boolean;
}

export class AprovacaoTranscricaoParmDTO {
  idPrescricao: number;
  idTranscricao: number;
  justifProducaoAdiantada: string;
}

export { ITranscription, ITranscriptionFilter };
